'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductDetailsDescription = function () {
  function ProductDetailsDescription(el) {
    (0, _classCallCheck3.default)(this, ProductDetailsDescription);

    this.shortDesc = el.querySelector('[data-el="product-details-description.shortDescription"]');
    this.longDesc = el.querySelector('[data-el="product-details-description.longDescription"]');
    this.triggers = el.querySelectorAll('[data-el="product-details-description.trigger"]');

    if (!this.longDesc || !this.triggers) {
      return;
    }

    this.isOpen = false;

    this.setupListeners();
  }

  (0, _createClass3.default)(ProductDetailsDescription, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.triggers.forEach(function (trigger) {
        trigger.addEventListener('click', _this.handleCLick.bind(_this));
      });
    }
  }, {
    key: 'handleCLick',
    value: function handleCLick() {
      this.isOpen ? this.hideLongDesc() : this.showLongDesc();
    }
  }, {
    key: 'showLongDesc',
    value: function showLongDesc() {
      var _this2 = this;

      this.isOpen = true;

      // Check full height of long desc
      var fullHeight = this.calcLongDescFullHeight();

      // Prepare styles for height transition
      this.longDesc.style.setProperty('height', this.shortDesc.offsetHeight + 'px');
      this.longDesc.style.setProperty('position', 'static');

      this.toggleAriaHidden();
      this.toggleOpacity();
      this.toggleTriggerText();

      // Adjust height to reveal long desc - https://www.justjeb.com/post/why-does-settimeout-work
      window.setTimeout(function () {
        _this2.longDesc.style.setProperty('height', fullHeight + 'px');
      }, 0);

      // Wait 0.5s for animation to finish before applying height auto
      window.setTimeout(function () {
        _this2.longDesc.style.setProperty('height', 'auto');
      }, 500);
    }
  }, {
    key: 'hideLongDesc',
    value: function hideLongDesc() {
      var _this3 = this;

      this.isOpen = false;

      // Give long desc an actual height value
      this.longDesc.style.setProperty('height', this.longDesc.offsetHeight + 'px');

      // Adjust height to reveal long desc - https://www.justjeb.com/post/why-does-settimeout-work
      window.setTimeout(function () {
        _this3.longDesc.style.setProperty('height', '0');
      }, 0);

      this.toggleAriaHidden();
      this.toggleOpacity();
      this.toggleTriggerText();
    }
  }, {
    key: 'calcLongDescFullHeight',
    value: function calcLongDescFullHeight() {
      this.longDesc.style.setProperty('opacity', '0');
      this.longDesc.style.setProperty('position', 'absolute');
      this.longDesc.style.setProperty('height', 'auto');
      return this.longDesc.offsetHeight;
    }
  }, {
    key: 'toggleOpacity',
    value: function toggleOpacity() {
      this.shortDesc.style.setProperty('opacity', this.isOpen ? 0 : 1);
      this.longDesc.style.setProperty('opacity', this.isOpen ? 1 : 0);
    }
  }, {
    key: 'toggleAriaHidden',
    value: function toggleAriaHidden() {
      if (this.isOpen) {
        this.shortDesc.setAttribute('aria-hidden', 'true');
        this.longDesc.removeAttribute('aria-hidden');
      } else {
        this.shortDesc.removeAttribute('aria-hidden');
        this.longDesc.setAttribute('aria-hidden', 'true');
      }
    }
  }, {
    key: 'toggleTriggerText',
    value: function toggleTriggerText() {
      var _this4 = this;

      this.triggers.forEach(function (trigger) {
        trigger.innerText = _this4.isOpen ? 'Read less' : 'Read more';
      });
    }
  }]);
  return ProductDetailsDescription;
}();

exports.default = ProductDetailsDescription;